export const SAVE_CHANGE_PASSWORD_ERROR = 'Password changed error!'
export const SAVE_CHANGE_PASSWORD_SUCCESS = 'Password changed successfully!'
export const DISCARD_CHANGE_PASSWORD_ERROR = 'Discard error!'
export const SAME_PASSWORD_ERROR = 'Old password and new password is the same!'
export const CONFIRM_PASSWORD_ERROR = 'Password confirmation doesn\'t match the new password!'
